import React from "react";

const ErrorPage = () => {
  return <div>Something went wrong with PicMe App👨🏻‍💼</div>;
};

export default ErrorPage;
